import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=325c5e42&scoped=true"
import script from "./ClientManage.vue?vue&type=script&lang=js"
export * from "./ClientManage.vue?vue&type=script&lang=js"
import style0 from "./ClientManage.vue?vue&type=style&index=0&id=325c5e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c5e42",
  null
  
)

export default component.exports